export const COLORS = {
  darkModeBg: "#010219",
  white: "#FFFFFF",
  black: "#000000",
  grey: "#262636",
  lightGrey: "#D9D9D9",
  // green: "#1D8C23",
  green: "#0c6c9e",
  darkGrey: "#2D3748",
  lightBrown: "#DCDCDC",
  chartbg: "#242438",
  // lightGreen: "#E4F3E5",
  lightGreen: "rgba(7, 47, 103, 0.8)",

  //AAHERA COLOrs(LIGHT MODE)
  primary: "#0c6c9e",
  primaryDark: "rgb(3, 23, 48)",

  // primary: "#1D8C23",
  // primaryDark: "#1D8C23",
  primaryLight: "rgba(7, 47, 103, 0.8)",
  secondary: "#FC7067",
  bgGrey: "#F7F7F7",
  bgColor: "#0c6c9e",
  bgColorLight: "#F9F9F9",
  lightPink: "#FEE8E7",
};
